var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmnipresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#848484",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 6,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,8H8.5L8,9L7.5,8H7C6.45,8,6,8.45,6,9v2c0,0.55,0.45,1,1,1v2.5C7,14.775,7.225,15,7.5,15C7.775,15,8,14.775,8,14.5   C8,14.775,8.225,15,8.5,15C8.775,15,9,14.775,9,14.5V12c0.55,0,1-0.45,1-1V9C10,8.45,9.55,8,9,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,3C6.346,3,5,4.346,5,6c0,0.583,0.173,1.158,0.5,1.663C5.65,7.894,5.961,7.96,6.192,7.81   c0.231-0.15,0.297-0.46,0.147-0.692C6.117,6.776,6,6.39,6,6c0-1.103,0.897-2,2-2c1.103,0,2,0.897,2,2   c0,0.39-0.117,0.776-0.339,1.118C9.511,7.349,9.576,7.659,9.808,7.81C9.892,7.864,9.986,7.89,10.08,7.89   c0.163,0,0.323-0.08,0.419-0.228C10.827,7.158,11,6.583,11,6C11,4.346,9.654,3,8,3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,1C5.243,1,3,3.243,3,6c0,0.989,0.292,1.949,0.844,2.777c0.153,0.229,0.463,0.29,0.693,0.139   c0.229-0.153,0.292-0.463,0.139-0.693C4.234,7.559,4,6.791,4,6c0-2.206,1.794-4,4-4c2.206,0,4,1.794,4,4   c0,0.79-0.233,1.559-0.676,2.223c-0.153,0.229-0.091,0.54,0.139,0.693C11.548,8.973,11.645,9,11.74,9   c0.161,0,0.32-0.078,0.416-0.223C12.708,7.948,13,6.988,13,6C13,3.243,10.757,1,8,1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmnipresent);
export default __webpack_public_path__ + "static/media/omnipresent.953b66ca15e0d2cd091ade27b6923962.svg";
export { ForwardRef as ReactComponent };